// removed by extract-text-webpack-plugin
module.exports = {"noResults":"noResults--lyR4Y"};